module.exports = __webpack_public_path__ + "media/images/default_image-fc89825e5796df2ffb39f049b583d143.png";